import { render } from "./BaseModal.vue?vue&type=template&id=27e6b13d"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/digitalmasters/team-wombat/alenus-bottle-o-ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__